import React from "react";
import { Divider, Skeleton, Typography } from "@mui/material";

import { BUTTON_TEXT, SECTION_TITLES } from "../constants";
import AddPaymentIcon from "../../../../components/Icons/AddPaymentIcon";
import { ICardListResponse } from "../../../../services/card-list/card-list.interface";
import PaymentCardList from "../../../../components/PaymentCardList/PaymentCardList";
import { StyledBookingFlowButton } from "../../BookingScheduleContainer/BookingScheduleContainer.style";
import { billCycle } from "../types";

interface IPaymentMethodSectionProps {
  billingCycle: billCycle;
  cardList: ICardListResponse | null;
  loading: boolean;
  getPaymentList: (cardList: ICardListResponse) => any[];
  handleAddPayment: () => void;
}

export const PaymentMethodSection = ({
  billingCycle,
  cardList,
  loading,
  getPaymentList,
  handleAddPayment,
}: IPaymentMethodSectionProps) => {
  const isDisabled = billingCycle === "perMonth";

  return (
    <section className="w-full px-4 space-y-2">
      <Divider className="w-full" sx={{ borderColor: "taupe.dark", my: 1.5 }} />
      <Typography
        variant="body2"
        className="geograph-regular"
        color="black.main"
        sx={{
          fontWeight: 600,
          lineHeight: "12px",
          fontSize: "12px",
          opacity: isDisabled ? 0.6 : 1,
        }}
      >
        {SECTION_TITLES.PAYMENT_METHOD}
      </Typography>
      <div
        className={isDisabled ? "opacity-60 pointer-events-none" : ""}
        aria-disabled={isDisabled}
      >
        {!loading ? (
          <>
            {cardList && cardList.cards.length > 0 ? (
              <PaymentCardList
                cardDetailsList={getPaymentList(cardList)}
                disableExpand={true}
                enableSelection={!isDisabled && getPaymentList(cardList).length !== 1}
              />
            ) : (
              <StyledBookingFlowButton
                fullWidth
                color="primary"
                size="small"
                className="bg-transparent border-1 border-light-black hover:text-light-black"
                onClick={handleAddPayment}
                disabled={isDisabled}
              >
                <AddPaymentIcon width={17} height={17} />
                {BUTTON_TEXT.ADD_PAYMENT_METHOD}
              </StyledBookingFlowButton>
            )}
          </>
        ) : (
          <Skeleton animation="wave" height={100} />
        )}
      </div>
    </section>
  );
};
